import { Stack, Typography } from "@mui/material";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import React from "react";

type Props = {};

const Copyright = (props: Props) => {
  return (
    <Stack 
      direction="column" 
      alignItems="flex-start" 
      p={2} 
      spacing={3}
      sx={{ maxWidth: 1100, margin: "0 auto", lineHeight: 1.7 }}
    >
      <Typography variant="h5" fontWeight="bold" textAlign="left">
        Copyright Policy
      </Typography>

      <Typography variant="h6" textAlign="justify" fontWeight="bold">
        This website and its content are the copyright of Modern College of
        Physiotherapy.
        <Typography fontSize='14' textAlign="justify" fontWeight="normal">
        © Modern College of Physiotherapy. All rights reserved.
      </Typography>
      </Typography>

      <Stack direction="column" spacing={2}>
        <Typography variant="body1" textAlign="justify">
          Any redistribution or reproduction of part or all of the contents in
          any form is prohibited other than the following:
        </Typography>

        <Stack direction="row" spacing={1} alignItems="flex-start">
          <ArrowForwardIosIcon
            sx={{
              color: "text.secondary",
              fontSize: "medium",
              minWidth: "fit-content",
            }}
          />
          <Typography variant="body1" textAlign="justify">
            You may print or download to a local hard disk extracts for your
            personal and non-commercial use only.
          </Typography>
        </Stack>

        <Stack direction="row" spacing={1} alignItems="flex-start">
          <ArrowForwardIosIcon
            sx={{
              color: "text.secondary",
              fontSize: "medium",
              minWidth: "fit-content",
            }}
          />
          <Typography variant="body1" textAlign="justify">
            You may copy the content to individual third parties for their
            personal use, but only if you acknowledge the website as the source of
            the material.
          </Typography>
        </Stack>

        <Stack direction="row" spacing={1} alignItems="flex-start">
          <ArrowForwardIosIcon
            sx={{
              color: "text.secondary",
              fontSize: "medium",
              minWidth: "fit-content",
            }}
          />
          <Typography variant="body1" textAlign="justify">
            You may not, except with our express written permission, distribute or
            commercially exploit the content. Nor may you transmit it or store it
            in any other website or other form of electronic retrieval system.
          </Typography>
        </Stack>
      </Stack>
    </Stack>
  );
};

export default Copyright;
